import React from 'react';
import { Platform } from 'react-native';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import useResponsiveness from '@/hooks/useResponsiveness';
import CreditsRequiredCard from '@/components/Credits/CreditsRequiredCard';

function CreditsRequiredDropdown({
  TriggerComponent,
  triggerComponentProps={},
  noRoot,
  requestCost,
  holdCost,
  fileEstimate,
  onOpenChange,
}) {

  const { isXS } = useResponsiveness();

  const [open, setOpen] = React.useState(false);
  const handleOpenChange = (next) => {
    setOpen(next);
    onOpenChange && onOpenChange(next);
  };

  const content = (
    <>
      {TriggerComponent && (
        <DropdownMenu.Trigger>
          <TriggerComponent {...triggerComponentProps} />
        </DropdownMenu.Trigger>
      )}

      <DropdownMenu.Content 
        className={Platform.OS === 'web' ? "DropdownMenuContent" : undefined}
        align={isXS ? 'center' : 'end'} 
        sideOffset={isXS ? 4 : 5}
      >
        <CreditsRequiredCard requestCost={requestCost} holdCost={holdCost} fileEstimate={fileEstimate} onClose={() => setOpen(false)} />
      </DropdownMenu.Content>
    </>
  );

  if (noRoot) {
    return content;
  }

  return (
    <DropdownMenu.Root open={open} onOpenChange={handleOpenChange}>
      {content}
    </DropdownMenu.Root>
  );
}

export default React.memo(CreditsRequiredDropdown);
